import React, { useEffect, useState, useRef } from "react";

import { auth, firebase } from "../../Firebase/config";

import {
    onSnapshot,
    orderBy,
    limit,
    collection,
    addDoc,
    query,
    where,
    getDocs,
    deleteDoc,
    doc,
    setDoc,
    getDoc,
    updateDoc,
    arrayUnion,
    FieldValue,
    getCountFromServer,
    arrayRemove,
} from "@firebase/firestore";

import {
    Link,
    Route,
    Routes,
    useParams,
    useNavigate,
    useLocation,
} from "react-router-dom";

import "../Messages.css";


export default function Phonelessstudents({
    currentclass,
    activename,
    activeid,
    selectedclass,
    currentstudent,
    setCurrentstudent,
    parentlanguagecode,
    id2,
    classidd,
    additionallinklevel,
    setShowcurrentroster,
    setShowcurrentpasses,
    getschoolid,
    town,
    state, school,
    userdata2,
    showcurrentpasses, setCurrentpass, currentpassid,
    teacherid,
    teacheridforreturn,
    teacher,
    coursename,
    activeid2,
    linkedclass,
    setUserdata2,
    setSendEmail,
    bathroompasslimit,
    minutespromptingemail,
    whowillbeemailed,
    newgreeting,
    newgreetinga,
    setMinutespromptingemail,
    setWhowillemailed,
    setNewgreeting,
    setNewgreetinga,
    setBathroompasslimit,
}) {
    const [lasttwomonths, setlasttwomonths] = useState([]);

    const [searchingstate, setSearchingstate] = useState(false);
    const [aallpasses, setAallpasses] = useState();

    const [filteredstates, setFilteredstates] = useState([]);

    const [activpasses, setActivpasses] = useState([]);
    const [update, setUpdate] = useState();

    const [changehasbeenmade, setChangehasbeenmade] = useState();
    const [endtime, setEndtime] = useState();
    const [begintime, setBegintime] = useState();

    const [revise, setRevise] = useState();

    const [passesbetween, setPassesbetween] = useState();

    const [currentclass2, setCurrentclass2] = useState();

    const [website, setWebsite] = useState();
    const [whatparentssee, setWhatpareentseee] = useState();


    const [phonenumberbefore2, setPhonenumberbefore2] = useState("");
    const [editparentcontactinfo, setEditparentcontactinfo] = useState(false);

    const [parentemail, setParentemail] = useState("");

    const [visibleStudents, setVisibleStudents] = useState([]);

    const [selectedStudentAnimating, setSelectedStudentAnimating] = useState(false);
    const [detailsVisible, setDetailsVisible] = useState(false);

    const [selectedIndex, setSelectedIndex] = useState(0);

    const [parentlanguage, setParentlanguage] = useState("");

    const [newparentlanguage, setNewparentlanguage] = useState("");
    const [language2, setLanguage2] = useState("");
    const [languagecode2, setLanguagecode2] = useState("");
    const [parentlanguagecode2, setParentlanguagecode2] = useState("");
    const [day, setDay] = useState();
    const [leftclass, setLeftclass] = useState();
    const [currentlocation, setCurrentlocation] = useState("From School");
    const [parentlanguage2, setParentlanguage2] = useState("");
    const [pnumber, setPnumber] = useState("");

    const [leavetimeGlobal, setLeavetimeGlobal] = useState();
    const [rightnow, setRightnow] = useState();
    const [whenpassbegan, setWhenpassbegan] = useState();
    const [allottedtime, setAllottedtime] = useState(480);
    const [currentdate, setCurrentdate] = useState("");
    const [realtimeleave, setRealtimeleave] = useState("");
    const [realtimereturn, setRealtimereturn] = useState("");


    const [destination, setDestination] = useState("");
    const [passexists, setPassexists] = useState("");
    const [passid, setPassid] = useState("");
    const [completed, setCompleted] = useState(false);
    const [passismade, setPassismade] = useState(false);
    const [expectedreturn, setExpectedreturn] = useState();
    const [iamenrolled2, setIamenrolled2] = useState(false);
    const [lengthofclasssession, setLengthofclasssession] = useState(60);
    const [notificationid, setNotificationid] = useState();
    const [gotteachernotificationid, setGotteachernotificationid] = useState();

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");

    const [visiblePasses, setVisiblePasses] = useState([]);

    const [userdata, setUserdata] = useState();
    const [showsettingsmodal, setShowsettingsmodal] = useState(false);
    const [wanttosend, setWanttosend] = useState(false);


    const navigate = useNavigate();

    const justPasted = React.useRef(false);



    useEffect(() => {
        console.log("userdata2 value:", userdata2);
        console.log("userdata2 type:", typeof userdata2);
        console.log("Is array?", Array.isArray(userdata2));
        console.log("Length:", userdata2?.length);

        if (Array.isArray(userdata2) && userdata2.length > 0 && showcurrentpasses) {
            // Reset visible passes when the component mounts or passes change
            setVisiblePasses([]);

            // Staggered animation to reveal passes one by one
            userdata2.forEach((pass, index) => {
                setTimeout(() => {
                    setVisiblePasses(prev => [...prev, pass.id || index]);
                }, 100 * index); // 100ms delay between each pass
            });
        }

        // Clean up effect when component unmounts or passes are hidden
        return () => {
            if (!showcurrentpasses) {
                setVisiblePasses([]);
            }
        };
    }, [userdata2, showcurrentpasses]);

    const selectHandler5 = (value, i) => {
        if (value && currentpassid != value.id) {

            setCurrentpass(value);
        } else {
            setCurrentpass("");

        }
    };

    const returnpass = async (value) => {
        if (value) {
            try {
                console.log("Returning pass:", value, "Returning pass:");

                const nowTime = Date.now();
                const quickCloseThreshold = (value.leftclass || 0) + 60000;
                const isQuickCloseDelete = typeof value.leftclass === "number" && nowTime <= quickCloseThreshold;

                console.log("[Quick Close Check][Teacher Return] Evaluating return path", {
                    passId: value.id,
                    studentId: value.studentid,
                    classId: value.classid,
                    leftclass: value.leftclass,
                    nowTime,
                    quickCloseThreshold,
                    isQuickCloseDelete,
                });

                if (isQuickCloseDelete) {
                    console.log("[Quick Close Delete] Deleting teacher-view pass before normal return flow", {
                        passId: value.id,
                        studentId: value.studentid,
                        classId: value.classid,
                        leftclass: value.leftclass,
                        nowTime,
                    });

                    if (getschoolid) {
                        await updateDoc(doc(firebase, "schools", getschoolid), {
                            update: nowTime,
                        });
                    }

                    if (value.studentid) {
                        await updateDoc(doc(firebase, "users", value.studentid), {
                            passid: "",
                            status: "",
                        });
                    }

                    if (teacherid) {
                        await updateDoc(doc(firebase, "users", teacherid), {
                            addingnumber: nowTime,
                            idofstudent: value.studentid,
                            passnumber: value.id
                        });
                    }

                    await deleteDoc(doc(firebase, "passes", value.id));

                    setUserdata2(prev => Array.isArray(prev) ? prev.filter(p => p?.id !== value.id) : prev);
                    setVisiblePasses(prev => Array.isArray(prev) ? prev.filter(id => id !== value.id) : prev);
                    setCurrentpass("");
                    return;
                }

                console.log("[Quick Close Retain][Teacher Return] Pass retained and continuing through normal return flow", {
                    passId: value.id,
                    studentId: value.studentid,
                    classId: value.classid,
                    leftclass: value.leftclass,
                    nowTime,
                });

                const expectedReturn = ((value.timeallowedonpass * 60000) + value.leftclass);
                const timeDifference = (expectedReturn - nowTime) / 60000;

                const currentDate = new Date();
                const formattedTime = currentDate.toLocaleTimeString([], {
                    hour12: true,
                    timeStyle: "short",
                });

                const passdetails = { overunder: timeDifference, timeended: nowTime, passid: value.id }

                // Update the pass record
                await updateDoc(doc(firebase, "passes", value.id), {
                    returned: nowTime,
                    timereturned: formattedTime,
                    returnedbeforetimelimit: timeDifference === 0 || timeDifference >= 0,
                    differenceoverorunderinminutes: timeDifference
                });

                // Update the student's record
                if (value.studentid) {
                    await updateDoc(doc(firebase, "users", value.studentid), {
                        [`${value.classid}.notlateonhallpaass`]: timeDifference >= 0,
                        [`${value.classid}.passdetails`]: arrayUnion(passdetails),
                        ...(timeDifference < 0 ? {
                            [`${value.classid}.lastmistake`]: "Late On A Pass",
                            [`${value.classid}.lastmistaketime`]: Date.now(),
                        } : {}),
                        passid: "",
                        status: "",
                    });
                }

                // Update the teacher's record (this is likely already the current user)
                if (teacherid) {
                    await updateDoc(doc(firebase, "users", teacherid), {
                        addingnumber: nowTime,
                        idofstudent: value.studentid,
                        passnumber: value.id
                    });
                }

                // Update school record if needed
                if (getschoolid) {
                    await updateDoc(doc(firebase, "schools", getschoolid), {
                        update: nowTime,
                    });
                }

                // Update the local state to reflect the returned pass
                const updatedPass = { ...value, returned: nowTime, timereturned: formattedTime };
                setUserdata2(prev => {
                    if (Array.isArray(prev)) {
                        return prev.map(p => p.id === value.id ? updatedPass : p);
                    }
                    return prev;
                });

                // Clear current pass selection
                setCurrentpass("");

                // Show success message
                console.log(`Pass for ${value.firstname} ${value.lastname} has been returned.`);

            } catch (error) {
                console.error("Error returning pass:", error);
                alert("There was a problem returning the pass: " + error.message);
            } finally {
                console.log("Return pass process completed for pass ID:", value.id);
            }
        } else if (value) {
            alert("This pass has already been returned.");
        }
    };

    const deletepass = (value) => {
        if (value) {
            const userDoc = doc(firebase, "passes", value.id);

            deleteDoc(userDoc).then(async () => {
                // Remove the deleted pass from local userdata state
                setUserdata2(prev => Array.isArray(prev) ? prev.filter(p => p?.id !== value.id) : prev);

                // Also remove from visiblePasses so it doesn't animate back in
                setVisiblePasses(prev => Array.isArray(prev) ? prev.filter(id => id !== value.id) : prev);

                // Clear current pass selection
                setCurrentpass("");
            });

        }
    };

    const deletepassbefore = (value) => {
        if (value) {


            // Create a modal overlay
            const modal = document.createElement("div");
            modal.style.position = "fixed";
            modal.style.top = 0;
            modal.style.left = 0;
            modal.style.width = "100vw";
            modal.style.height = "100vh";
            modal.style.background = "rgba(0,0,0,0.5)";
            modal.style.display = "flex";
            modal.style.alignItems = "center";
            modal.style.justifyContent = "center";
            modal.style.opacity = .95
            modal.style.zIndex = 9999;

            // Modal content
            const content = document.createElement("div");
            content.style.background = "#000";
            content.style.padding = "32px 24px";
            content.style.borderRadius = "12px";
            content.style.boxShadow = "0 4px 24px rgba(0,0,0,0.15)";
            content.style.textAlign = "center";
            content.style.minWidth = "260px";
            content.style.maxWidth = "90vw";

            const title = document.createElement("div");
            title.innerHTML = "Please be aware:<br>This will permantnetly delete<br> this pass from the system.";
            title.style.fontSize = "1.2rem";
            title.style.fontWeight = "bold";
            title.style.marginBottom = "20px";
            title.style.color = "white";
            content.appendChild(title);

            const destinations = [
                { label: "Delete This Pass", value: "Delete" },
            ];

            destinations.forEach(dest => {
                const btn = document.createElement("button");
                btn.textContent = dest.label;
                btn.style.margin = "8px";
                btn.style.padding = "10px 18px";
                btn.style.fontSize = "18px";
                btn.style.width = "90%";
                btn.style.borderRadius = "6px";
                btn.style.display = "block"
                btn.style.marginLeft = "auto";
                btn.style.marginRight = "auto";
                btn.style.border = "4px solid #e43522";
                btn.style.background = "#013469";
                btn.style.color = "#fff";
                btn.style.cursor = "pointer";
                btn.onmouseover = () => btn.style.background = "#0256a6";
                btn.onmouseout = () => btn.style.background = "#013469";
                btn.onclick = (e) => {
                    // Stop event propagation
                    e.stopPropagation();
                    // Add explicit alert for testing
                    console.log(value, "deletingggg");

                    try {
                        document.body.removeChild(modal);
                        deletepass(value);
                    } catch (error) {
                        console.error("Error during deletion:", error);
                    }
                };
                content.appendChild(btn);
            });

            // Optional: Add a cancel button
            const cancelBtn = document.createElement("button");
            cancelBtn.textContent = "Cancel";
            cancelBtn.style.margin = "8px";
            cancelBtn.style.padding = "10px 18px";
            cancelBtn.style.fontSize = "1rem";
            cancelBtn.style.borderRadius = "6px";
            cancelBtn.style.border = "none";
            cancelBtn.style.background = "#ccc";
            cancelBtn.style.color = "#333";
            cancelBtn.style.cursor = "pointer";
            cancelBtn.onclick = () => {
                document.body.removeChild(modal);
            };
            content.appendChild(document.createElement("br"));
            content.appendChild(cancelBtn);

            modal.appendChild(content);
            document.body.appendChild(modal);
        }


    };




    useEffect(() => {
        if (currentclass && currentclass.length > 0) {
            // Reset visible students when component mounts or currentclass changes
            setVisibleStudents([]);

            // Staggered animation to reveal students one by one
            currentclass.forEach((student, index) => {
                setTimeout(() => {
                    setVisibleStudents(prev => [...prev, student.id]);
                }, 100 * index); // 200ms delay between each student (1/5 second)
            });
        }

        // Clean up effect when component unmounts
        return () => {
            setVisibleStudents([]);
        };
    }, [currentclass]);

    useEffect(() => {
        let date = Date.now();
        console.log(activename, "hellooooo");
        setRevise(date);
    }, [activename, activeid]);

    useEffect(() => {
        if (typeof currentstudent != "undefined") {
            console.log(currentstudent, "currentstudentttt");

            // Set student-specific data
            setFirstname(currentstudent.localfirstname || currentstudent.firstname || "");
            setLastname(currentstudent.locallastname || currentstudent.lastname || "");

            // Set language settings
            setLanguage2(currentstudent.language || "English");
            setLanguagecode2(currentstudent.languagecode || "en");
            setParentlanguage2(currentstudent.parentlanguage || "English");
            setParentlanguagecode2(currentstudent.parentlanguagecode || "en");


            // Set contact info
            if (Array.isArray(currentstudent.parentphonenumber) && currentstudent.parentphonenumber.length > 0) {
                setPnumber(currentstudent.parentphonenumber);
            } else {
                setPnumber(currentstudent.phonenumber || "");
            }

            // Set default pass parameters
            setAllottedtime(480); // Default to 8 minutes (480 seconds)
            setCurrentlocation("From Class");
            setIamenrolled2(true);
            setLengthofclasssession(60); // Default class length in minutes
        }
    }, [currentstudent]);


    const organizepasses = async () => {
        if (!Array.isArray(userdata2) || userdata2.length === 0) {
            console.log("userdata2 is not a valid array or is empty");
            setUserdata([]);
            return;
        }

        console.log("Organizing passes from userdata2:", userdata2);

        try {
            // Split passes into two groups: active (returned == 0) and completed (returned > 0)
            const activePasses = userdata2.filter(pass => pass && pass.returned === 0);
            const completedPasses = userdata2.filter(pass => pass && pass.returned > 0);

            // Sort active passes by leftclass in descending order (more recent passes at top)
            const sortedActivePasses = [...activePasses].sort((a, b) => {
                // Handle potential missing or invalid leftclass values
                const aValue = typeof a.leftclass === 'number' ? a.leftclass : 0;
                const bValue = typeof b.leftclass === 'number' ? b.leftclass : 0;
                return bValue - aValue; // Descending order (higher values first)
            });

            // Sort completed passes by leftclass in descending order
            const sortedCompletedPasses = [...completedPasses].sort((a, b) => {
                const aValue = typeof a.leftclass === 'number' ? a.leftclass : 0;
                const bValue = typeof b.leftclass === 'number' ? b.leftclass : 0;
                return bValue - aValue; // Descending order
            });

            // Combine the two sorted groups with active passes first
            const organizedPasses = [...sortedActivePasses, ...sortedCompletedPasses];

            console.log("Passes organized successfully:", {
                originalCount: userdata2.length,
                organizedCount: organizedPasses.length,
                activeCount: sortedActivePasses.length,
                completedCount: sortedCompletedPasses.length
            });

            // Update the userdata state with the organized passes
            setUserdata(organizedPasses);
        } catch (error) {
            console.error("Error organizing passes:", error);
            // Fallback to original array in case of error
            setUserdata(userdata2);
        }

    }

    useEffect(() => {
        if (typeof selectedclass != "undefined") {
            console.log(selectedclass, "selectedclassss");

            // Set class-specific data
            // setCoursename(selectedclass.classname || "");
            // setActiveid2(selectedclass.key || "");
            // setLinkedclass(selectedclass.key || "");

            // Set teacher data (assuming the current user is the teacher)

            // setTeacherid(id2);
            // setTeacheridforreturn(id2);
            // setTeacher(selectedclass.teacheriscalled || "");

            // Set destination defaults
            // setDestination("Bathroom");

            // Reset pass state for new class selection
            setPassexists("");
            setPassid("");
            setCompleted(false);
            setPassismade(false);

            // Set the day to undefined to trigger finalizehallpass when date is set
            setDay(undefined);
        }
    }, [selectedclass]);


    useEffect(() => {
        if (typeof userdata2 != "undefined") {

            organizepasses()
        }
    }, [userdata2]);




    return (
        <div className="inner123">
            {/* Settings Modal */}
            {showsettingsmodal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.85)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999
                }}>
                    <div style={{
                        background: "#000",
                        padding: "32px 24px",
                        borderRadius: "16px",
                        boxShadow: "0 4px 24px rgba(0,0,0,0.35)",
                        minWidth: "340px",
                        maxWidth: "95vw",
                        color: "#fff",
                        border: "4px solid #E43522"
                    }}>
                        <div style={{ fontWeight: "bold", fontSize: "30px", marginBottom: 16, color: "#fff" }}>'Lateness' Email Settings<br></br>____________</div>

                        <div style={{ marginBottom: 12, fontWeight: 500, color: "#fff" }}>Pass Time That Triggers Email Option</div>

                        <span style={{ marginLeft: 12, color: "#fff", fontWeight: 600 }}>{minutespromptingemail} minutes</span>
                        <div style={{ marginBottom: 8 }}>
                            <input type="range" min={bathroompasslimit || 0} max={100} step={1}
                                value={typeof minutespromptingemail !== "undefined" ? minutespromptingemail : 100}
                                onChange={e => setMinutespromptingemail(Number(e.target.value))}
                                style={{ width: 300, accentColor: "#E43522" }} />

                        </div>
                        <div style={{ marginBottom: 12, fontWeight: 500, color: "#fff" }}>Email Will Send To:</div>
                        <span style={{ marginLeft: 12, color: "#fff", fontWeight: 600 }}>
                            {whowillbeemailed === 0 ? "the Student" : whowillbeemailed === 1 ? "the Parent" : "Both Parent and Student"}
                        </span>
                        <div style={{ marginBottom: 8 }}>
                            <input type="range" min={0} max={2} step={1}
                                value={typeof whowillbeemailed !== "undefined" ? whowillbeemailed : 2}
                                onChange={e => setWhowillemailed(Number(e.target.value))}
                                style={{ width: 300, accentColor: "#E43522" }} />

                        </div>
                        <div style={{ marginTop: 18, marginBottom: 6, fontWeight: 500, color: "#fff" }}>Student Message About Lateness</div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <textarea
                                    style={{
                                        width: 340,
                                        minHeight: 180,
                                        borderRadius: 10,
                                        border: '2px solid #E43522',
                                        padding: 10,
                                        background: '#013469',
                                        color: '#fff',
                                        fontSize: 18,
                                        transition: 'background 0.2s'
                                    }}
                                    placeholder="Corresponding Student Message"
                                    value={newgreeting}
                                    onChange={e => setNewgreeting(e.target.value)}
                                    onMouseOver={e => e.currentTarget.style.background = '#0256a6'}
                                    onMouseOut={e => e.currentTarget.style.background = '#013469'}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8, gap: 8 }}>
                                    <button
                                        type="button"
                                        title="Insert '{Student Name}'"
                                        style={{ background: '#222', color: '#fff', border: '2px solid #E43522', borderRadius: 8, fontSize: 32, width: 45, height: 45, cursor: 'pointer', marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => {
                                            const insert = '{Student Name}';
                                            setNewgreeting((prev) => (prev ? prev + ' ' + insert : insert));
                                        }}
                                        data-tooltip="{Student Name}"
                                    >🧑‍🎓</button>
                                    <button
                                        type="button"
                                        title="Insert '{Student Time}'"
                                        style={{ background: '#222', color: '#fff', border: '2px solid #E43522', borderRadius: 8, fontSize: 32, width: 45, height: 45, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => {
                                            const insert = '{Student Time}';
                                            setNewgreeting((prev) => (prev ? prev + ' ' + insert : insert));
                                        }}
                                        data-tooltip="{Student Time}"
                                    >🕓</button>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: 18, marginBottom: 6, fontWeight: 500, color: "#fff" }}>Parent Message About Lateness</div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <textarea
                                    style={{
                                        width: 340,
                                        minHeight: 180,
                                        borderRadius: 10,
                                        border: '2px solid #E43522',
                                        padding: 10,
                                        background: '#013469',
                                        color: '#fff',
                                        fontSize: 18,
                                        transition: 'background 0.2s'
                                    }}
                                    placeholder="Corresponding Parent Message"
                                    value={newgreetinga}
                                    onChange={e => setNewgreetinga(e.target.value)}
                                    onMouseOver={e => e.currentTarget.style.background = '#0256a6'}
                                    onMouseOut={e => e.currentTarget.style.background = '#013469'}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8, gap: 8 }}>
                                    <button
                                        type="button"
                                        title="Insert '{Student Name}'"
                                        style={{ background: '#222', color: '#fff', border: '2px solid #E43522', borderRadius: 8, fontSize: 32, width: 45, height: 45, cursor: 'pointer', marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => {
                                            const insert = '{Student Name}';
                                            setNewgreetinga((prev) => (prev ? prev + ' ' + insert : insert));
                                        }}
                                        data-tooltip="{Student Name}"
                                    >🧑‍🎓</button>
                                    <button
                                        type="button"
                                        title="Insert '{Student Time}'"
                                        style={{ background: '#222', color: '#fff', border: '2px solid #E43522', borderRadius: 8, fontSize: 32, width: 45, height: 45, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        onClick={() => {
                                            const insert = '{Student Time}';
                                            setNewgreetinga((prev) => (prev ? prev + ' ' + insert : insert));
                                        }}
                                        data-tooltip="{Student Time}"
                                    >🕓</button>
                                </div>
                            </div>
                        </div>

                        <div style={{ fontWeight: "bold", fontSize: "30px", marginBottom: 16, color: "#fff" }}>____________</div>
                        <div style={{ marginTop: 18 }}>
                            <button
                                style={{
                                    margin: "8px",
                                    padding: "10px 18px",
                                    fontSize: "17px",
                                    width: "90%",
                                    borderRadius: "6px",
                                    display: "block",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    border: "2px solid #e43522",
                                    background: "#013469",
                                    color: "#fff",
                                    cursor: "pointer",
                                    transition: "background 0.2s"
                                }}
                                onMouseOver={e => e.currentTarget.style.background = "#0256a6"}
                                onMouseOut={e => e.currentTarget.style.background = "#013469"}
                                onClick={async () => {
                                    try {
                                        await updateDoc(doc(firebase, "users", teacherid), {
                                            minutespromptingemail: minutespromptingemail,
                                            whowillbeemailed: whowillbeemailed,
                                            studentpassmessage: newgreeting,
                                            parentpassmessage: newgreetinga,
                                        });
                                        alert("Settings Saved! Your settings have been saved successfully.");
                                        setShowsettingsmodal(false);
                                    } catch (error) {
                                        console.log(error);
                                        alert("There was a problem saving your settings.");
                                    }
                                }}
                            >Save These Settings</button>
                            <button style={{ padding: '10px 22px', background: '#222', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 16, letterSpacing: 0.5 }}
                                onClick={() => setShowsettingsmodal(false)}>
                                Cancel
                            </button>
                        </div>
                        <div style={{ marginTop: 24, fontSize: 13, color: '#fff', background: '#000', borderRadius: 8, padding: 12, marginBottom: 0 }}>
                            <div style={{ marginBottom: 8 }}><b>KEY:</b></div>
                            <div style={{ marginBottom: 8 }}><b>Name</b>: Use {'{Student Name}'} in your message to insert the student's name.</div>
                            <div><b>Time</b>: Use {'{Student Time}'} in your message to insert the pass time.</div>
                        </div>
                    </div>
                </div>
            )}
            {!userdata && showcurrentpasses && (
                <div className="loading-state" style={{ padding: "20px", textAlign: "center" }}>
                    Loading pass data...
                </div>
            )}

            {userdata && !Array.isArray(userdata) && showcurrentpasses && (
                <div className="error-state" style={{ padding: "20px", color: "red", textAlign: "center" }}>
                    Error: Pass data is not in the expected format.
                    Expected an array but got: {typeof userdata}
                </div>
            )}


            {(typeof currentpassid == "undefined" || currentpassid == "") && showcurrentpasses && typeof userdata !== "undefined" && userdata.length > 0 ? (
                <div className="selectstudentmessage">
                    (Today's Passes.)</div>) : null}

            {Array.isArray(userdata) && userdata.length === 0 && showcurrentpasses && (
                <div className="empty-state" style={{ padding: "20px", textAlign: "center" }}>
                    No passes found for today.
                </div>
            )}

            {Array.isArray(userdata) && userdata.length > 0 && showcurrentpasses && (
                <>
                    {userdata.map((item, index) => {
                        try {
                            return (
                                <React.Fragment key={item?.id || index}>
                                    {/* Show pass list item if no student selected or this is the selected student and still animating */}
                                    {(typeof currentpassid == "undefined" || currentpassid == "") && item.returned == 0 ? (
                                        <div
                                            onClick={() => selectHandler5(item, index)}
                                            className={`${visiblePasses.includes(item?.id || index) ? "student-visible" : "student-hidden"} 
                            ${item?.id == currentpassid && selectedStudentAnimating ? "student-selected-animating" : ""}`}
                                        >
                                            <div className={
                                                (typeof item.whenlimitwillbereached === 'number' && item.whenlimitwillbereached > Date.now())
                                                    ? "passstart"
                                                    : "passstartlate"
                                            }
                                                onClick={() => console.log("select")}
                                            >
                                                {item?.firstname || "Unknown"} {item?.lastname || "Student"} <br></br>
                                                {item?.passdetailcurrentdate && item?.timeleftclass ?
                                                    <span>{item.passdetailcurrentdate} @ {item.timeleftclass}<br></br>{item.comingfrom || "Unknown"} to {item.destination || "Unknown"} - {item.timeallowedonpass + " minutes" || ""}</span>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    ) : (typeof currentpassid == "undefined" || currentpassid == "") && item.returned > 0 ? (
                                        <div
                                            onClick={() => selectHandler5(item, index)}
                                            className={`${visiblePasses.includes(item?.id || index) ? "student-visible" : "student-hidden"} 
                            ${item?.id == currentpassid && selectedStudentAnimating ? "student-selected-animating" : ""}`}
                                        >
                                            <div className={
                                                (typeof item.returned === 'number' && typeof item.whenlimitwillbereached === 'number' && item.whenlimitwillbereached > item.returned)
                                                    ? "passstart"
                                                    : "passstartlate"
                                            }
                                                onClick={() => console.log("select")}
                                            >
                                                {item?.firstname || "Unknown"} {item?.lastname || "Student"} <br></br>
                                                {item?.passdetailcurrentdate && item?.timeleftclass ?
                                                    <span>{item.passdetailcurrentdate} @ {item.timeleftclass}<br></br>{item.comingfrom || "Unknown"} to {item.destination || "Unknown"}  <br></br>Time Returned: {item.timereturned || "Unknown"} <br></br> Time Out Of Class: {((item.returned - item.timepassinitiated) / 60000).toFixed(1)} min.</span>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    ) : (typeof currentpassid == "undefined" || currentpassid == "" || item?.id === currentpassid) ?
                                        <div
                                            className="student-visible"
                                        >
                                            <div
                                                className="passstart"
                                                onClick={() => selectHandler5(item, index)}
                                            >
                                                {item?.firstname || "Unknown"} {item?.lastname || "Student"} <br></br>
                                                {item?.passdetailcurrentdate && item?.timeleftclass ?
                                                    <span>{item.passdetailcurrentdate} @ {item.timeleftclass}<br></br>{item.comingfrom || "Unknown"} to {item.destination || "Unknown"} <br></br>{item.timereturned ? "returned at " + item.timereturned : "Still Active"}</span>
                                                    : null
                                                }
                                            </div>

                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent triggering parent onClick
                                                    const currentIndex = userdata.findIndex(pass => pass.id === item.id);
                                                    const nextIndex = (currentIndex + 1) % userdata.length;
                                                    const nextPass = userdata[nextIndex];
                                                    setCurrentpass(nextPass);
                                                }}
                                                style={{
                                                    display: "inline-flex",
                                                    marginLeft: "10px",
                                                    cursor: "pointer",
                                                    backgroundColor: "#013469",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "30px",
                                                    height: "30px",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    transition: "transform 0.2s, background-color 0.2s"
                                                }}
                                                onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                                onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                title="Go to next pass"
                                            >
                                                →
                                            </div>
                                            <br></br>

                                            {item && wanttosend == false && item.returned > 0 && (((item.returned - item.leftclass) / 60000) < minutespromptingemail) ? <div
                                                className="passstart222"
                                                style={{ flex: 7, fontSize: "inherit", margin: 0 }}
                                                onClick={() => setShowsettingsmodal(true)}
                                            >
                                                <div
                                                    className="innertext">
                                                    Adjust 'Late Pass' Settings
                                                </div>
                                            </div> : item && wanttosend == false && item.returned > 0 ? <div className="passstart222"
                                                style={{ flex: 3, fontSize: "inherit", margin: 0 }} onClick={() => setWanttosend(true)}>
                                                <div className="innertext">Email About 'Lateness' to  {whowillbeemailed === 0 ? "the Student" : whowillbeemailed === 1 ? "the Parent" : "Parent and Student"}</div>
                                            </div> : item.returned > 0 ? <div className="passstart222divide" style={{ padding: 0, marginBottom: 10 }}>
                                                <div style={{ display: "flex", gap: 8, width: "100%" }}>
                                                    <div
                                                        className="passstart222"
                                                        style={{ flex: 7, fontSize: "inherit", margin: 0 }}
                                                        onClick={() => setShowsettingsmodal(true)}
                                                    >
                                                        <div
                                                            className="innertext">
                                                            Adjust 'Late Pass' Settings
                                                        </div>
                                                    </div>
                                                    <div className="passstart222"
                                                        style={{ flex: 3, fontSize: "inherit", margin: 0 }} onClick={() => setSendEmail(true)}>
                                                        <div className="innertext">Send Email</div>
                                                    </div>
                                                </div>
                                            </div> : null}

                                            <div className="passstart" onClick={() => deletepassbefore(item)}>
                                                <div className="innertext">Delete Pass</div>
                                            </div>
                                            {item.leftclass > 0 ? <div className="passstart" onClick={() => returnpass(item)}>
                                                <div className="innertext">Return Pass</div>
                                            </div> : null}

                                        </div>
                                        : null}
                                    {/* ... the rest of your existing rendering logic ... */}
                                </React.Fragment>
                            );
                        } catch (error) {
                            console.error("Error rendering pass item:", error, item);
                            return (
                                <div key={index} className="error-item" style={{ padding: "10px", margin: "5px", backgroundColor: "#ffdddd" }}>
                                    Error rendering pass item {index}. See console for details.
                                </div>
                            );
                        }
                    })}
                </>
            )}
            <br></br>
        </div>
    );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */
